import { styled } from '@styledComponents';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';

export const OrganizingGuestsTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 500px;
    ${themeMediaQuery('below_sm')} {
      width: 398px;
      max-width: 398px;
    }
    ${themeMediaQuery('xl')} {
      max-width: 635px;
    }
  }
`;

export const ResponsiveTextPairing = styled(TextPairing)`
  text-align: left;
  ${themeMediaQuery('below_sm')} {
    text-align: center;
  }
  .text-pairing-body {
    max-width: 280px;
    ${themeMediaQuery('below_sm')} {
      margin: auto;
      max-width: 235px;
    }
  }
`;

export const StyledBox = styled(Box)`
  position: relative;
  text-align: right;
  ${themeMediaQuery('below_sm')} {
    text-align: left;
  }
`;

export const StyledSvg = styled.svg`
  width: 65px;
  margin-left: -217px;
  padding-top: 58px;
  .draw {
    stroke: #2c2925;
    stroke-dasharray: 3200;
    stroke-dashoffset: 3200;
    animation: animate 7s forwards;
    animation-delay: 1s;
  }
  @keyframes animate {
    to {
      stroke-dashoffset: 0;
    }
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    margin-left: 20%;
  }
`;
